import { render, staticRenderFns } from "./DsfrTag.vue?vue&type=template&id=c1ec5a7e&"
import script from "./DsfrTag.vue?vue&type=script&lang=js&"
export * from "./DsfrTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports